import ImageMap from "image-map";

export const ResponsiveImageMaps = (function () {
	'use strict';

	function init() {
		let $map = $('img[usemap]');
		if(!$map.length > 0 ) return;
		ImageMap('img[usemap]');
		// events($map);
	}

	function events(map) {
		// console.log('works')
		map.imageMap();  
	}

	return {
		init: init,
	};
})();